import { db } from './index'
import { complements, type NewComplement, type Complement } from './schema'
import { eq, desc } from 'drizzle-orm'

export async function createComplement(data: NewComplement) {
    const [row] = await db.insert(complements).values(data).returning()
    return { success: true, data: row }
}

export async function listComplements() {
    const rows = await db.select().from(complements).orderBy(desc(complements.createdAt))
    return { success: true, data: rows }
}

export async function getComplement(id: string) {
    const [row] = await db.select().from(complements).where(eq(complements.id, id))
    return { success: true, data: row || null }
}

export async function updateComplement(id: string, data: Partial<Complement>) {
    const [row] = await db.update(complements).set({ ...data, updatedAt: new Date() }).where(eq(complements.id, id)).returning()
    return { success: true, data: row || null }
}

export async function deleteComplement(id: string) {
    const [row] = await db.delete(complements).where(eq(complements.id, id)).returning()
    return { success: true, data: row || null }
}
